
import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import checkAuth from './app/auth';
import AdminLayout from './layouts/AdminLayout';
import AllRouters from './routes/AllRouters';
import './index.css';

const Login = lazy(() => import('./components/pages/user/Login'));
const Dashboard = lazy(() => import('./layouts/Dashboard'));
const Header = lazy(() => import('./layouts/Header'));
const Menu = lazy(() => import('./layouts/Menu'));
const Footer = lazy(() => import('./layouts/Footer'));
const Coupons = lazy(() => import('./components/pages/Coupons'))

function App() {
  const isAuthenticated = checkAuth();

  return (
    <AllRouters />
  );
}

export default App;

